import { ClientAbsence } from 'RestAPIs/absence';

import { Dialog } from 'components/shared';

import AddAbsenceForm from './AddAbsenceForm';

type Props = {
  appointmentId?: string;
  appointmentStart: string;
  title: string;
  open: boolean;
  handleClose: () => void;
  clientId: string | undefined;
  clientName: string;
  editData?: ClientAbsence;
};

export default function AddAbsenceDialog({
  title,
  clientId,
  clientName,
  appointmentId,
  appointmentStart,
  open,
  handleClose,
  editData
}: Props) {
  return (
    <Dialog open={open} handleClose={handleClose} title={title}>
      <AddAbsenceForm
        appointmentId={appointmentId}
        appointmentStart={appointmentStart}
        clientId={clientId}
        handleClose={handleClose}
        clientAbsence={editData}
        clientName={clientName}
      />
    </Dialog>
  );
}
